import Cookies from "js-cookie";
import jwt_decode from "jwt-decode";

const tokenName = "token";

const isLoggedIn = () => {
  if (hasCookieExpired(tokenName)) {
    return false;
  }
  const token = Cookies.get(tokenName);
  return !!token; // Return true if token exists, false otherwise
};

const getToken = () => {
  const token = Cookies.get(tokenName);
  return token;
};

const decodeToken = (token) => {
  try {
    if (token !== null) {
      return jwt_decode(token);
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};

const hasCookieExpired = (cookieName) => {
  const tokenValue = Cookies.get(cookieName);

  if (tokenValue) {
    const expirationDate = new Date(tokenValue);
    const currentDate = new Date();
    return expirationDate < currentDate;
  }

  // If the 'token' cookie doesn't exist, treat it as expired
  return true;
};

const getTokenId = () => {
  const token = Cookies.get(tokenName);
  if (token === undefined) {
    return "";
  }
  const decodedToken = decodeToken(token);
  if (decodedToken !== null) {
    for (const key in decodedToken) {
      if (key.includes("nameidentifier")) {
        return decodedToken[key];
      }
    }
  }
};

const getTokenName = () => {
  const token = Cookies.get(tokenName);
  if (token === undefined) {
    return "";
  }
  const decodedToken = decodeToken(token);
  if (decodedToken !== null) {
    for (const key in decodedToken) {
      if (key.includes("name")){
        return decodedToken[key];
      }
    }
  }
};

const isAdmin = () => {
  const token = Cookies.get(tokenName);
  if (token === undefined) {
    return false;
  }

  const decodedToken = decodeToken(token);
  if (decodedToken !== null) {
    return decodedToken["admin"] === "True";
  } else {
    return false;
  }
};

const getTokenRole = () => {
  const token = Cookies.get(tokenName);
  if (token === undefined) {
    return "";
  }
  const decodedToken = decodeToken(token);
  if (decodedToken !== null) {
    for (const key in decodedToken) {
      if (key.includes("role")) {
        return decodedToken[key];
      }
    }
  }
};

const canAccessPage = (page) => {
    const token = Cookies.get(tokenName);
    if (token === undefined) {
      return false;
    }
    const decodedToken = decodeToken(token);
    if (decodedToken !== null) {
      for (const key in decodedToken) {
        if (key.includes("pages")) {
          const pages =  decodedToken[key];
          if(pages.includes(page)){
            return true;
          }
        }
      }
    }
    return false;
  };

  const getTokenEmail = () => {
    const token = Cookies.get(tokenName);
    if (token === undefined) {
      return "";
    }
    const decodedToken = decodeToken(token);
    if (decodedToken !== null) {
      for (const key in decodedToken) {
        if (key.includes("email")) {
          return decodedToken[key];
        }
      }
    }
  }

  const getTokenUser = () => {
    const token = Cookies.get(tokenName);
    if (token === undefined) {
      return "";
    }
    const decodedToken = decodeToken(token);
    if (decodedToken !== null) {
      for (const key in decodedToken) {
        if (key.includes("user")) {
          return decodedToken[key];
        }
      }
    }
  };

const setUserCookie = (token) => {
  Cookies.set(tokenName, token, { expires: 1 });
};

export {
  isLoggedIn,
  getToken,
  getTokenId,
  getTokenName,
  isAdmin,
  getTokenRole,
  setUserCookie,
  getTokenUser,
  canAccessPage,
  getTokenEmail,
};
